// eslint-disable-next-line angular/component-limit
angular.module('study.dashboard')
    .component('inclusionRatioReport', {
        templateUrl: 'modules/dashboard/components/inclusion-ratio-report/template.html',
    })